// extracted by css-extract-rspack-plugin
export default {"title":"title-rz05ZX","pause_container":"pause_container-lI8D2f","pauseContainer":"pause_container-lI8D2f","pauseScreen":"pauseScreen-OrVZaX","row":"row-IKim4t"};